export const sampleText = "Sample Text/Notes \nYou can Add new Workspaces from the end of the list and delete existing Workspaces.";
export const sampleData = [
  { name: "Workspace 0", color: "#2596be", text: sampleText },
  { name: "Workspace 1", color: "#0040ff", text: sampleText },
  { name: "Workspace 2", color: "#4080ec", text: sampleText },
];
